<template>
  <div v-cloak id="sitebody" :class="{ 'mobile': !isDesktop }">
    <!-- <div v-if="isDesktop && (!user || user.group === 1)" v-show="showVideoAd" class="videoroll">
      <div @click="showVideoAd = !showVideoAd">
        <i class="close" />
      </div>
      <div class="body">
        <div id="yandex_rtb_R-A-1202748-2"></div>
      </div>
    </div> -->
    
    <!--movieAds v-if="(!user || user.group === 1)" /-->

    <dark-component v-if="themeDark" />

    <!-- <bidvolVideoAds v-if="showAdBlock" /> -->

    <!-- <client-only>
      <particlesJS v-if="scrolled && $device.isDesktop" />
    </client-only> -->

    <mobile-component v-if="!isDesktop" />

    <div v-if="hints.yabrowser" class="site-hint yabrowser">
      <i @click="closeHint('yabrowser')" />
      <b style="color:red;">!</b><strong>У вас Яндекс.Браузер?</strong>.
      Оставьте отзыв о сайте, это очень поможет проекту. Спасибо!
      <span @click="closeHint('yabrowser')" class="close">Закрыть</span>
    </div>

    <!-- <div v-if="showAlert" class="user-alert">
      <alert-component />
      <div class="actions">
        <i @click="hideAlert" class="icon-close" />
      </div>
    </div> -->

    <menu-component />

    <need-friends :nfdata="enterData.nf" />

    <!-- <div id="adfox_165003171672471931" style="text-align:center;margin:20px auto;"></div> -->

    <template v-if="(!user || user.group === 1)">
      <div id="yandex_rtb_R-A-1202748-3" class="rsya-block"></div>
      <div class="dads" style="cursor:pointer;">
        <nuxt-link to="/store#premium">Убрать рекламу</nuxt-link>
      </div>
    </template>

    <div v-if="$route.name !== 'cinema-id' && $route.name !== 'tv'" class="main">
      <aside v-if="isDesktop || $route.name === 'index'" class="left-side">
        <bestComponent />

        <!-- <adSense /> -->

        <relatedReleased v-if="blocks['released']" />
        <div v-else data-block-id="released" class="related released lazy-block" />
      </aside>
      <div class="center-side">
        <nuxt />
      </div>
      <aside class="right-side">
        <!-- <adSense v-if="blocks['ggl0']" />
        <div v-else data-block-id="ggl0" class="lazy-block" /> -->
        
        <relatedUpdates v-if="blocks['updates']" />
        <div v-else data-block-id="updates" class="related updates lazy-block" />

        <relatedComments v-if="blocks['comments']" />
        <div v-else data-block-id="comments" class="lazy-block" />
      </aside>
    </div>
    <div v-else>
      <nuxt />
    </div>
    
    <!-- <adSense v-if="blocks['ggl1']" />
    <div v-else data-block-id="ggl1" class="lazy-block" /> -->
    <!-- <div id="adfox_165003177429817706" style="text-align:center;margin:0px auto 20px;"></div> -->

    <last-articles v-if="blocks['la']" />
    <div v-else data-block-id="la" class="last-articles lazy-block" />

    <footer-component v-if="blocks['ft']" />
    <div v-else data-block-id="ft" class="lazy-block" />

    <i onclick="window.scrollTo(0, 0)" class="scroll-up" />

    <transition name="toTop">
      <minimize-video v-if="minimizeVideo" />
    </transition>

    <client-only>
      <chat-component v-if="!['tv', 'cinema-id', 'chat'].includes(routeName)" />
    </client-only>

    <div v-if="notifis.length" class="push-notifications">
      <transition-group name="toTop" tag="div" class="list">
        <div v-for="noti in notifis" :key="`noti-${noti.title}`" class="item">
          <div class="body">
            <div class="avatar">
              <img v-if="noti.photo" :src="noti.photo" alt="">
              <img v-else src="/bot-avatar.png" alt="">
            </div>
            <div>
              <div class="header">
                <strong>{{ noti.title }}</strong>
                <!-- <time>{{ item.date }}</time> -->
                <i @click="closePush(noti.date, noti.name)" class="close" />
              </div>
              <p>
                {{ noti.text }}
              </p>
            </div>
          </div>
          <div>
            <button @click="closePush(noti.date, noti.name)" class="dbtn red">Закрыть</button>
            <nuxt-link
              v-for="btn in noti.buttons"
              :key="`noti-btn-${btn.text}`"
              :to="btn.link"
              :class="btn.color"
              tag="button"
              class="dbtn"
            >
              {{ btn.text }}
            </nuxt-link>
          </div>
        </div>
      </transition-group>
    </div>

    <transition name="fade">
      <div v-if="showGetFirstpet" class="first-pet">
        <div v-if="!firstPet" class="modal">
          <h2>
            Давай посмотрим какой питомец достанется тебе!
          </h2>
          <div>
            <img @click="getFirstPet" src="/static_files/items/etc/pokeball.svg" class="artifact" alt="artifact">
            <h3>!ЖМИ!</h3>
          </div>
          <p>
            <strong>Скорее нажми на покебол!</strong>
          </p>
        </div>
        <div v-else class="modal">
          <h2>
            Этот питомец выбрал тебя!
          </h2>
          <img :src="`/static_files/items/pet-${firstPet}.svg`" alt="pet">
          <p>
            <strong>Поздравляем! Питомец выбрал тебя и стал твоим первым питомцем!</strong>
          </p>
          <p>
            Проявляй активность на сайте, развивай свой профиль и получай новых питомцев в коллекцию!
          </p>
          <div class="buttons">
            <nuxt-link to="/store" tag="button" class="dbtn blue">Список питомцев</nuxt-link>
            <button @click="hideFirstpet" class="dbtn red">Все понятно, закрыть</button>
          </div>
        </div>
      </div>
    </transition>

    <div class="rewards-calendar">
      <transition name="toTop">
        <div v-if="showCalendar" class="body">
          <i @click="showCalendar = false" class="close" />
          <div class="info">
            <div>
              <h3>Подарки &#127873;</h3>
              <p>
                Просто заходи на сайт и получай подарки каждый день!
              </p>
            </div>

            <div>
              <h4>Особые подарки</h4>
              <span style="color:blue;">День {{ rewardsComplete.length }}</span>
              <ul>
                <li :class="{ active: rewardsComplete.length >= 7 }" title="EXP 1000">
                  <strong>7</strong>
                  <img src="/static_files/items/etc/exp.svg" alt="">
                </li>
                <li :class="{ active: rewardsComplete.length >= 14 }" title="Монеты 1">
                  <strong>14</strong>
                  <img src="/static_files/items/etc/sitecoin.svg" alt="">
                </li>
                <li :class="{ active: rewardsComplete.length >= 21 }" title="Рандомный итем (артефакт или питомец)">
                  <strong>21</strong>
                  <img src="/static_files/items/etc/pokeball.svg" alt="">
                </li>
                <li :class="{ active: rewardsComplete.length >= 28 }" title="Premium+ на 3 дня">
                  <strong>28</strong>
                  <img src="/static_files/items/etc/premium-quality.svg" alt="">
                </li>
              </ul>
            </div>
            <button
              v-if="rewardsComplete.find(el => el.date.slice(el.date.lastIndexOf('-') + 1) == (new Date().getDate()) )"
              class="dbtn yellow"
            >
              &#9989; Получен
            </button>
            <button
              v-else
              @click="keepReward('day')"
              :class="{ gray: calendarTimer }"
              class="dbtn"
            >
              {{ !calendarTimer ? 'Получить' : `Доступно через ${calendarTimer} сек.` }}
            </button>
            <strong>
              <nuxt-link to="/donate">Еще монеты</nuxt-link>
            </strong>
          </div>
          <div class="days">
            <div
              v-for="(d, i) in daysCount"
              :key="`rewards-calendar-${d}`"
              class="item"
              :class="{ active: rewardsComplete.find(el => el.date.slice(el.date.lastIndexOf('-') + 1) == (i + 1) ) }"
            >
              <span class="day">{{ d }}</span>
              <div class="sitecoin exp">
                <i />
                <span>{{ rewardsList[i].exp }}</span>
              </div>
              <div class="sitecoin">
                <i />
                <span>{{ rewardsList[i].coin }}</span>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div v-if="hints.calendar" class="site-hint calendar">
        <i @click="closeHint('calendar')" />
        <b style="color:red;">!</b><strong>Подсказка</strong>.
        Заходи на сайт и получай подарки каждый день.
        <span @click="closeHint('calendar')" class="close">Закрыть</span>
      </div>
      <transition name="toTop">
        <div
          v-if="!showCalendar"
          class="icon-calendar"
        >
          <i @click="openCalendar" />
        </div>
      </transition>
    </div>

    <div v-if="showAndroidApp" class="is-android-app">
      <i @click="hideApp" />
      <h4>У вас Android?</h4>
      <p>
        Скачайте наше мобильное приложение для Android и пользуйтесь сайтом
        еще удобнее!
      </p>
      <a href="/static_files/app/android_latest.apk" download>Скачать</a>
      <span @click="hideApp">Закрыть</span>
    </div>

    <error-component v-if="error" :error="error" />

    <!-- <marketPlace v-if="(!user || (user.group !== 77 && user.group !== 777))" /> -->
    <!-- <videoRoll v-if="(!user || (user.group !== 77 && user.group !== 777))" /> -->
    <!-- <adlook v-if="!user || (user.group !== 777 && user.group !== 0)" /> -->

    <tv-component v-if="$route.name !== 'tv' && $route.name !== 'cinema-id'" />

    <transition name="fade">
      <feedback-component v-if="feedback" />
    </transition>

    <transition :name="!isDesktop ? 'toTop' : 'toLeft'">
      <interview-component v-if="showInterview" />
    </transition>

    <!-- SAPE RTB DIV 600x340 -->
    <!-- <div v-if="(!user || (user.group !== 77 && user.group !== 777))" id="SRTB_729333"></div> -->
    <!-- SAPE RTB END -->

    <!-- <counters-component v-if="showCounters" /> -->

    <!-- <div id="adfox_165000964221329647"></div> -->
  </div>
</template>

<script>
// import LazyHydrate from 'vue-lazy-hydration'
import Vue from 'vue'
import { mapState } from 'vuex'
import global from '~/mixins/global.js'

Vue.mixin(global)

export default {
  components: {
    // movieAds: () => import('~/components/movieAds.vue'),
    // LazyHydrate,
    // alertComponent: () => import('~/components/alertComponent.vue'),
    // speedbarComponent: () => import('~/components/speedbarComponent.vue'),
    // gglAds: () => import('~/components/gglAds.vue'),
    // particlesJS: () => import('~/components/particlesJS.vue'),
    // linksComponent: () => import('~/components/linksComponent.vue'),
    relatedComments: () => import('~/components/relatedComments.vue'),
    relatedReleased: () => import('~/components/relatedReleased.vue'),
    relatedUpdates: () => import('~/components/relatedUpdates.vue'),
    bestComponent: () => import('~/components/bestComponent.vue'),
    darkComponent: () => import('~/components/darkComponent.vue'),
    // countersComponent: () => import('~/components/countersComponent.vue'),
    // adSense: () => import('~/components/adSense.vue'),
    // adlook: () => import('~/components/adlook.vue'),
    // marketPlace: () => import('~/components/marketPlace.vue'),
    // bidvolVideoAds: () => import('~/components/bidvolVideoAds.vue'),
    // videoRoll: () => import('~/components/videoRoll.vue'),
    mobileComponent: () => import('~/components/mobileComponent.vue'),
    menuComponent: () => import('~/components/menuComponent.vue'),
    needFriends: () => import('~/components/needFriends.vue'),
    lastArticles: () => import('~/components/lastArticles.vue'),
    tvComponent: () => import('~/components/tvComponent.vue'),
    chatComponent: () => import('~/components/chatComponent.vue'),
    feedbackComponent: () => import('~/components/feedbackComponent.vue'),
    errorComponent: () => import('~/components/errorComponent.vue'),
    footerComponent: () => import('~/components/footerComponent.vue'),
    interviewComponent: () => import('~/components/interviewComponent.vue'),
    minimizeVideo: () => import('~/components/minimizeVideo.vue')
  },
  watch: {
    user() {
      this.setColorize()
    },
    changeRoute() {
      // setTimeout(() => this.showAds(), 100)

//       if (!this.isDesktop && (!this.user || (this.user.group !== 777 && this.user.group !== 0))) {
//         if (this.showFS) return
//         const rsyaMobileFS = document.createElement('script')
//         rsyaMobileFS.innerHTML = `
// window.yaContextCb.push(()=>{
//   Ya.Context.AdvManager.render({
//     type: 'fullscreen',
//     blockId: 'R-A-1202748-4'
//   })
// })`
//         document.body.appendChild(rsyaMobileFS)
//         this.showFS = true
//       }

      this.setColorize()

      if (this.firstPet) this.hideFirstpet()

      // this.blocks = {
      //   ggl0: false,
      //   ggl1: false,
      //   ggl2: false,
      //   la: false,
      //   ft: false
      // }

      // this.checkShowVideoroll()

      document.body.style.overflow = ''

      document
        .querySelectorAll('section')
        .forEach(s => (s.style.backgroundColor = ''))

      if (this.isDesktop) {
        setTimeout(() => {
          const elem = document.querySelector('.need-friends')
          if (elem) {
            elem.style.paddingTop = '130px'
          }
        }, 100)
      }

      this.notifis = []
      this.showCalendar = false

      this.scrolled = false

      // this.showCounters = false

      // this.$nextTick(() => {
      //   this.showCounters = true
      // })

      setTimeout(() => {
        this.lazyLoadImgs()
      }, 400)
    }
  },
  computed: {
    ...mapState([
      'error', 'feedback', 'isDesktop', 'user', 'enterData', 'minimizeVideo',
      'themeDark', 'showAdsGlobal', 'tabActive'
    ]),
    routeName() {
      return this.$route.name
    },
    changeRoute() {
      return this.$route.fullPath
    },
    showChat() {
      return !(
        this.$route.name === 'tv' ||
        this.$route.name === 'cinema-id' ||
        this.$route.name === 'success' ||
        this.$route.name === 'chat'
      )
    },
    loader() {
      const loads = ['spookyghost', 'bluecat', 'cutiefox', 'kakidog', 'midorikappa', 'pinkpig']
      return loads[Math.floor(Math.random() * loads.length)]
    }
  },
  data() {
    const nextMonth = new Date(new Date().setMonth(new Date().getMonth() + 1))
    const firstDay = new Date(new Date(nextMonth).setDate(1))
    const prevMonth = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() - 1))

    const daysCount = new Date(prevMonth).getDate()

    return {
      showFS: false,
      showVideoAd: true,
      showAdBlock: false,
      blocks: {
        ggl0: false,
        ggl1: false,
        ggl2: false,
        la: false,
        ft: false,
        released: false,
        updates: false,
        comments: false
      },
      showInterview: false,
      showAndroidApp: false,
      daysCount,
      showCalendar: false,
      showGetFirstpet: false,
      firstPet: null,
      gets: {},
      notifis: [],
      // showUpdates: false,
      // showAlert: false,
      // showFooter: false,
      hints: {
        calendar: false,
        yabrowser: false
      },
      rewardsList: [],
      rewardsComplete: [],
      rewardsCompleteWeek: [],
      calendarTimer: 60,
      calendarInterval: null,
      // showVideoroll: true,
      // loaded: false,
      scrolled: false,
      showCounters: true
    }
  },
  mounted() {
    if (['anime777.ru', 'anime777.fun', 'anime777.su',].includes(window.location.hostname)) {
      setTimeout(() => {
        location.href = 'https://anime777.site'
      }, 1000)
    }

    if (this.user && this.user.group !== 1) {
      const elem = document.querySelector('[data-hid="adfinity"]')
      if (elem) {
        document.head.removeChild(elem)
      }
    }

    this.getEnterData()

    setInterval(() => {
      this.showVideoAd = true
    }, 10 * 60 * 1000)
    
    // const night = new Date().getHours() >= 0 && new Date().getHours() <= 8

    // if (
    //   localStorage.getItem('show_ads') || night
    // ) {
    //   this.showAds()
    // } else {
    //   // setTimeout(() => {
    //   //   this.showAds()
    //   // }, 10 * 1000)
    //   setTimeout(() => {
    //     this.showAds()
    //   }, 15 * 1000)
    // }

    this.showAds()
    
    // if (
    //   localStorage.getItem('multiwin') &&
    //   localStorage.getItem('multiwin') > Date.now() - 100
    // ) {
    //   localStorage.setItem('multiwin', JSON.stringify(Date.now()))
    //   alert('Слишком частые запросы')
    // } else {
    //   localStorage.setItem('multiwin', JSON.stringify(Date.now()))
    // }

    // Inside page components
    // this.$OneSignal.push(() => {
    //     this.$OneSignal.isPushNotificationsEnabled((isEnabled) => {
    //     if (isEnabled) {
    //       console.log('Push notifications are enabled!')
    //     } else {
    //       console.log('Push notifications are not enabled yet.')
    //     }
    //   })
    // })

    // if (localStorage.getItem('localized')) document.body.setAttribute('data-localized', 'en')

    // if (localStorage.getItem('theme')) {
    //   if (localStorage.getItem('theme') === 'dark') {
    //     document.body.className = 'dark'
    //   } else {
    //     document.body.className = ''
    //   }
    // }
    // else {
    //   const hours = new Date().getHours()
    //   if (!(hours > 6 && hours < 20)) document.body.className = 'dark'
    // }
    // await this.isAuth()

    // this.$store.commit('setDevice', this.$device)

    const dateMonth = new Date().getFullYear() + '-' + new Date().getMonth()
    const dateDay = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getMonth()

    // const isoDate = new Date().toISOString()
    // const enterDate = new Date(new Date(isoDate).setDate(new Date(isoDate).getDate() + 1)).getTime() + (1000 * 60 * 3)

    // if (!localStorage.getItem('first_enter')) {
    //   localStorage.setItem('first_enter', enterDate)
    //   this.firstEnter = true
    // } else if (localStorage.getItem('first_enter') < new Date(isoDate).getTime()) {
    //   this.firstEnter = false
    // } else {
    //   this.firstEnter = true
    // }

    if (this.$route.query?.ref && !localStorage.getItem('ref')) {
      localStorage.setItem('ref', this.$route.query.ref)
    }

    this.calendarInterval = setInterval(() => {
      if (!this.calendarTimer) {
        clearInterval(this.calendarInterval)
      } else {
        --this.calendarTimer
      }
    }, 1000)

    if (this.user) {
      if (localStorage.getItem('ref') && !localStorage.getItem('ref_complete')) {
        setTimeout(async () => {
          const { data } = await this.$axios.get(`/api/referrals?ref=${localStorage.getItem('ref')}`)
          if (data.error) {
            console.log(data.error.message)
          } else {
            // console.log(data)
            localStorage.setItem('ref_complete', 'true')
          }
        }, 30 * 1000)
      }

      if (!Object.prototype.hasOwnProperty.call(this.user, 'pet')) {
        this.showGetFirstpet = true
      }

      if (this.user.group === 1 && !localStorage.getItem(`push_premium-activate_${dateDay}`)) {
        setTimeout(() => {
          localStorage.setItem(`push_premium-activate_${dateDay}`, 'true')
          const obj = {
            date: dateDay,
            name: 'premium-activate',
            photo: `/static_files/items/pet-0.svg`,
            title: 'Срок вашей Premium подписки истек',
            text: 'Хотите обновить подписку и продолжить пользоваться сайтом без рекламы?',
            buttons: [
              {
                text: 'Подключить Premium',
                link: '/store',
                color: 'blue'
              }
            ]
          }
          this.notifis.push(obj)
        }, 15 * 1000)
      }

      if (!localStorage.getItem(`push_battles_promo_${dateMonth}`)) {
        setTimeout(() => {
          const obj = {
            date: dateMonth,
            name: 'battles_promo',
            photo: this.user.pet
              ? `/static_files/items/pet-${this.user.pet}.svg`
              : '/bot-avatar.png',
            title: 'Новая забава, "Битвы персонажей"!',
            text: 'Поучаствуй в "Битве персонажей аниме" и помоги любимому герою победить!',
            buttons: [
              {
                text: 'Принять участие!',
                link: '/apps/battles',
                color: 'green'
              }
            ]
          }
          this.notifis.push(obj)
        }, 120 * 1000)
      } else if (!localStorage.getItem(`push_quiz_${dateMonth}`)) {
        setTimeout(() => {
          const obj = {
            date: dateMonth,
            name: 'quiz',
            photo: this.user.pet
              ? `/static_files/items/pet-${this.user.pet}.svg`
              : '/bot-avatar.png',
            title: 'Насколько хорошо ты знаешь героев аниме?',
            text: 'Поучаствуй в "Аниме викторине" и покажи насколько хорошо ты знаешь аниме и персонажей!',
            buttons: [
              {
                text: 'Проверить себя',
                link: '/apps/quiz',
                color: 'green'
              }
            ]
          }
          this.notifis.push(obj)
        }, 120 * 1000)
      }

      if (!localStorage.getItem(`push_sitehelp_${dateDay}`)) {
        setTimeout(() => {
          const obj = {
            date: dateDay,
            name: 'sitehelp',
            title: 'Давай поможем сайту!',
            photo: this.user.pet
              ? `/static_files/items/pet-${this.user.pet}.svg`
              : '/bot-avatar.png',
            text: 'Выполни парочку заданий и получи монеты, которые можно потратить на Premium подписки и покупку артефактов.',
            buttons: [
              {
                text: 'Выполнить',
                link: '/donate#free',
                color: 'green'
              },
              {
                text: 'Артефакты?',
                link: '/store',
                color: 'blue'
              }
            ]
          }
          this.notifis.push(obj)
        }, 180 * 1000)
      } else if (!localStorage.getItem(`push_subs_${dateMonth}`)) {
        setTimeout(() => {
          const obj = {
            date: dateMonth,
            name: 'subs',
            title: 'Не пропусти выход новых серий!',
            photo: this.user.pet
              ? `/static_files/items/pet-${this.user.pet}.svg`
              : '/bot-avatar.png',
            text: 'Я могу присылать тебе уведомления о выходе онгоингов, хочешь составить список?',
            buttons: [
              {
                text: 'Подписаться',
                link: '/subscribe',
                color: 'green'
              }
            ]
          }
          this.notifis.push(obj)
        }, 180 * 1000)
      }

      setTimeout(() => {
        Object.keys(this.hints).forEach(type => {
          if (!localStorage.getItem(`hint_${type}`)) {
            if (type === 'yabrowser') {
              const ua = navigator.userAgent
              if (ua.search(/YaBrowser/) > 0) {
                this.hints[type] = true
              }
            }
            this.hints[type] = true
          }
        })
      }, 300 * 1000)
    } else if (!localStorage.getItem(`push_first-pet_${dateDay}`)) {
      setTimeout(() => {
        const obj = {
          date: dateDay,
          name: 'first-pet',
          photo: `/static_files/items/pet-0.svg`,
          title: 'Хай! Ты у нас впервые?',
          text: 'Дарим питомца и Premium подписку за регистрацию, присоединяйся!',
          buttons: [
            {
              text: 'Забрать подарки',
              link: '/profile',
              color: 'blue'
            }
          ]
        }
        this.notifis.push(obj)
      }, 15 * 1000)
    }

    setTimeout(() => {
      if (this.$device.isAndroid && !localStorage.getItem('android_app')) {
        this.showAndroidApp = true
      } else if (!localStorage.getItem('interview_modal')) {
        this.showInterview = true
      }
    }, 600 * 1000)

    // window.addEventListener('load', () => {
    //   this.loaded = true
    // })

    window.addEventListener('scroll', () => {
      const elem = document.querySelector('.scroll-up')

      if (elem) {
        if (document.documentElement.scrollTop > 3000) {
          elem.style.display = 'block'
        } else {
          elem.style.display = 'none'
        }
      }
    })

    window.addEventListener('scroll', this.showBlock)

    // this.checkShowVideoroll()
    this.setColorize()
    this.showBlock()

    const vm = this

    let hidden = "hidden";

    // Standards:
    if (hidden in document) {
      document.addEventListener("visibilitychange", onchange);
    } else if ((hidden = "mozHidden") in document) {
      document.addEventListener("mozvisibilitychange", onchange);
    } else if ((hidden = "webkitHidden") in document) {
      document.addEventListener("webkitvisibilitychange", onchange);
    } else if ((hidden = "msHidden") in document) {
      document.addEventListener("msvisibilitychange", onchange);
    } else if ("onfocusin" in document) {
      // IE 9 and lower:
      document.onfocusin = document.onfocusout = onchange;
    } else {
      // All others:
      window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
    }

    function onchange (evt) {
      if (!vm.$route.name === 'cinema-id') {
        return
      }

      const v = "visible"
      const h = "hidden"
      const evtMap = {
        focus: v,
        focusin: v,
        pageshow: v,
        blur: h,
        focusout: h,
        pagehide: h
      };

      evt = evt || window.event;

      if (evt.type in evtMap) {
        document.body.className = evtMap[evt.type];
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', evtMap[evt.type] === 'hidden' ? 0 : 1)
        }
      } else {
        document.body.className = this[hidden] ? "hidden" : "visible";
        if (vm.isDesktop) {
          // if (!vm.playerPlay)
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        } else {
          vm.$store.commit('setTabActive', this[hidden] ? 0 : 1)
        }
      }
      // console.log(vm.tabActive)
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined) {
      onchange({ type: document[hidden] ? "blur" : "focus" });
    }

    document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
    window.addEventListener('resize', () => { 
      document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
    })
  },
  methods: {
    async getEnterData() {
      const { data } = await this.$axios.get('/api/enterpoint')
      if (!data.error) {
        this.$store.commit('setEnterData', data)
      }
    },
    showAds() {
      if (!this.user || this.user.group === 1) {
        localStorage.setItem('show_ads', Date.now())

        this.showAdBlock = true

        // const clickadilla = document.createElement('script')
        // clickadilla.setAttribute('data-cfasync','falseanime777.site
        // clickadilla.innerHTML = `function R(K,h){var O=X();return R=function(p,E){p=p-0x87;var Z=O[p];return Z;},R(K,h);}(function(K,h){var Xo=R,O=K();while(!![]){try{var p=parseInt(Xo(0xac))/0x1*(-parseInt(Xo(0x90))/0x2)+parseInt(Xo(0xa5))/0x3*(-parseInt(Xo(0x8d))/0x4)+parseInt(Xo(0xb5))/0x5*(-parseInt(Xo(0x93))/0x6)+parseInt(Xo(0x89))/0x7+-parseInt(Xo(0xa1))/0x8+parseInt(Xo(0xa7))/0x9*(parseInt(Xo(0xb2))/0xa)+parseInt(Xo(0x95))/0xb*(parseInt(Xo(0x9f))/0xc);if(p===h)break;else O['push'](O['shift']());}catch(E){O['push'](O['shift']());}}}(X,0x33565),(function(){var XG=R;function K(){var Xe=R,h=22420,O='a3klsam',p='a',E='db',Z=Xe(0xad),S=Xe(0xb6),o=Xe(0xb0),e='cs',D='k',c='pro',u='xy',Q='su',G=Xe(0x9a),j='se',C='cr',z='et',w='sta',Y='tic',g='adMa',V='nager',A=p+E+Z+S+o,s=p+E+Z+S+e,W=p+E+Z+D+'-'+c+u+'-'+Q+G+'-'+j+C+z,L='/'+w+Y+'/'+g+V+Xe(0x9c),T=A,t=s,I=W,N=null,r=null,n=new Date()[Xe(0x94)]()[Xe(0x8c)]('T')[0x0][Xe(0xa3)](/-/ig,'.')['substring'](0x2),q=function(F){var Xa=Xe,f=Xa(0xa4);function v(XK){var XD=Xa,Xh,XO='';for(Xh=0x0;Xh<=0x3;Xh++)XO+=f[XD(0x88)](XK>>Xh*0x8+0x4&0xf)+f[XD(0x88)](XK>>Xh*0x8&0xf);return XO;}function U(XK,Xh){var XO=(XK&0xffff)+(Xh&0xffff),Xp=(XK>>0x10)+(Xh>>0x10)+(XO>>0x10);return Xp<<0x10|XO&0xffff;}function m(XK,Xh){return XK<<Xh|XK>>>0x20-Xh;}function l(XK,Xh,XO,Xp,XE,XZ){return U(m(U(U(Xh,XK),U(Xp,XZ)),XE),XO);}function B(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&XO|~Xh&Xp,XK,Xh,XE,XZ,XS);}function y(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&Xp|XO&~Xp,XK,Xh,XE,XZ,XS);}function H(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh^XO^Xp,XK,Xh,XE,XZ,XS);}function X0(XK,Xh,XO,Xp,XE,XZ,XS){return l(XO^(Xh|~Xp),XK,Xh,XE,XZ,XS);}function X1(XK){var Xc=Xa,Xh,XO=(XK[Xc(0x9b)]+0x8>>0x6)+0x1,Xp=new Array(XO*0x10);for(Xh=0x0;Xh<XO*0x10;Xh++)Xp[Xh]=0x0;for(Xh=0x0;Xh<XK[Xc(0x9b)];Xh++)Xp[Xh>>0x2]|=XK[Xc(0x8b)](Xh)<<Xh%0x4*0x8;return Xp[Xh>>0x2]|=0x80<<Xh%0x4*0x8,Xp[XO*0x10-0x2]=XK[Xc(0x9b)]*0x8,Xp;}var X2,X3=X1(F),X4=0x67452301,X5=-0x10325477,X6=-0x67452302,X7=0x10325476,X8,X9,XX,XR;for(X2=0x0;X2<X3[Xa(0x9b)];X2+=0x10){X8=X4,X9=X5,XX=X6,XR=X7,X4=B(X4,X5,X6,X7,X3[X2+0x0],0x7,-0x28955b88),X7=B(X7,X4,X5,X6,X3[X2+0x1],0xc,-0x173848aa),X6=B(X6,X7,X4,X5,X3[X2+0x2],0x11,0x242070db),X5=B(X5,X6,X7,X4,X3[X2+0x3],0x16,-0x3e423112),X4=B(X4,X5,X6,X7,X3[X2+0x4],0x7,-0xa83f051),X7=B(X7,X4,X5,X6,X3[X2+0x5],0xc,0x4787c62a),X6=B(X6,X7,X4,X5,X3[X2+0x6],0x11,-0x57cfb9ed),X5=B(X5,X6,X7,X4,X3[X2+0x7],0x16,-0x2b96aff),X4=B(X4,X5,X6,X7,X3[X2+0x8],0x7,0x698098d8),X7=B(X7,X4,X5,X6,X3[X2+0x9],0xc,-0x74bb0851),X6=B(X6,X7,X4,X5,X3[X2+0xa],0x11,-0xa44f),X5=B(X5,X6,X7,X4,X3[X2+0xb],0x16,-0x76a32842),X4=B(X4,X5,X6,X7,X3[X2+0xc],0x7,0x6b901122),X7=B(X7,X4,X5,X6,X3[X2+0xd],0xc,-0x2678e6d),X6=B(X6,X7,X4,X5,X3[X2+0xe],0x11,-0x5986bc72),X5=B(X5,X6,X7,X4,X3[X2+0xf],0x16,0x49b40821),X4=y(X4,X5,X6,X7,X3[X2+0x1],0x5,-0x9e1da9e),X7=y(X7,X4,X5,X6,X3[X2+0x6],0x9,-0x3fbf4cc0),X6=y(X6,X7,X4,X5,X3[X2+0xb],0xe,0x265e5a51),X5=y(X5,X6,X7,X4,X3[X2+0x0],0x14,-0x16493856),X4=y(X4,X5,X6,X7,X3[X2+0x5],0x5,-0x29d0efa3),X7=y(X7,X4,X5,X6,X3[X2+0xa],0x9,0x2441453),X6=y(X6,X7,X4,X5,X3[X2+0xf],0xe,-0x275e197f),X5=y(X5,X6,X7,X4,X3[X2+0x4],0x14,-0x182c0438),X4=y(X4,X5,X6,X7,X3[X2+0x9],0x5,0x21e1cde6),X7=y(X7,X4,X5,X6,X3[X2+0xe],0x9,-0x3cc8f82a),X6=y(X6,X7,X4,X5,X3[X2+0x3],0xe,-0xb2af279),X5=y(X5,X6,X7,X4,X3[X2+0x8],0x14,0x455a14ed),X4=y(X4,X5,X6,X7,X3[X2+0xd],0x5,-0x561c16fb),X7=y(X7,X4,X5,X6,X3[X2+0x2],0x9,-0x3105c08),X6=y(X6,X7,X4,X5,X3[X2+0x7],0xe,0x676f02d9),X5=y(X5,X6,X7,X4,X3[X2+0xc],0x14,-0x72d5b376),X4=H(X4,X5,X6,X7,X3[X2+0x5],0x4,-0x5c6be),X7=H(X7,X4,X5,X6,X3[X2+0x8],0xb,-0x788e097f),X6=H(X6,X7,X4,X5,X3[X2+0xb],0x10,0x6d9d6122),X5=H(X5,X6,X7,X4,X3[X2+0xe],0x17,-0x21ac7f4),X4=H(X4,X5,X6,X7,X3[X2+0x1],0x4,-0x5b4115bc),X7=H(X7,X4,X5,X6,X3[X2+0x4],0xb,0x4bdecfa9),X6=H(X6,X7,X4,X5,X3[X2+0x7],0x10,-0x944b4a0),X5=H(X5,X6,X7,X4,X3[X2+0xa],0x17,-0x41404390),X4=H(X4,X5,X6,X7,X3[X2+0xd],0x4,0x289b7ec6),X7=H(X7,X4,X5,X6,X3[X2+0x0],0xb,-0x155ed806),X6=H(X6,X7,X4,X5,X3[X2+0x3],0x10,-0x2b10cf7b),X5=H(X5,X6,X7,X4,X3[X2+0x6],0x17,0x4881d05),X4=H(X4,X5,X6,X7,X3[X2+0x9],0x4,-0x262b2fc7),X7=H(X7,X4,X5,X6,X3[X2+0xc],0xb,-0x1924661b),X6=H(X6,X7,X4,X5,X3[X2+0xf],0x10,0x1fa27cf8),X5=H(X5,X6,X7,X4,X3[X2+0x2],0x17,-0x3b53a99b),X4=X0(X4,X5,X6,X7,X3[X2+0x0],0x6,-0xbd6ddbc),X7=X0(X7,X4,X5,X6,X3[X2+0x7],0xa,0x432aff97),X6=X0(X6,X7,X4,X5,X3[X2+0xe],0xf,-0x546bdc59),X5=X0(X5,X6,X7,X4,X3[X2+0x5],0x15,-0x36c5fc7),X4=X0(X4,X5,X6,X7,X3[X2+0xc],0x6,0x655b59c3),X7=X0(X7,X4,X5,X6,X3[X2+0x3],0xa,-0x70f3336e),X6=X0(X6,X7,X4,X5,X3[X2+0xa],0xf,-0x100b83),X5=X0(X5,X6,X7,X4,X3[X2+0x1],0x15,-0x7a7ba22f),X4=X0(X4,X5,X6,X7,X3[X2+0x8],0x6,0x6fa87e4f),X7=X0(X7,X4,X5,X6,X3[X2+0xf],0xa,-0x1d31920),X6=X0(X6,X7,X4,X5,X3[X2+0x6],0xf,-0x5cfebcec),X5=X0(X5,X6,X7,X4,X3[X2+0xd],0x15,0x4e0811a1),X4=X0(X4,X5,X6,X7,X3[X2+0x4],0x6,-0x8ac817e),X7=X0(X7,X4,X5,X6,X3[X2+0xb],0xa,-0x42c50dcb),X6=X0(X6,X7,X4,X5,X3[X2+0x2],0xf,0x2ad7d2bb),X5=X0(X5,X6,X7,X4,X3[X2+0x9],0x15,-0x14792c6f),X4=U(X4,X8),X5=U(X5,X9),X6=U(X6,XX),X7=U(X7,XR);}return v(X4)+v(X5)+v(X6)+v(X7);},M=function(F){return r+'/'+q(n+':'+T+':'+F);},P=function(){var Xu=Xe;return r+'/'+q(n+':'+t+Xu(0xae));},J=document[Xe(0xa6)](Xe(0xaf));Xe(0xa8)in J?(L=L[Xe(0xa3)]('.js',Xe(0x9d)),J[Xe(0x91)]='module'):(L=L[Xe(0xa3)](Xe(0x9c),Xe(0xb4)),J[Xe(0xb3)]=!![]),N=q(n+':'+I+':domain')[Xe(0xa9)](0x0,0xa)+Xe(0x8a),r=Xe(0x92)+q(N+':'+I)[Xe(0xa9)](0x0,0xa)+'.'+N,J[Xe(0x96)]=M(L)+Xe(0x9c),J[Xe(0x87)]=function(){window[O]['ph'](M,P,N,n,q),window[O]['init'](h);},J[Xe(0xa2)]=function(){var XQ=Xe,F=document[XQ(0xa6)](XQ(0xaf));F['src']=XQ(0x98),F[XQ(0x99)](XQ(0xa0),h),F[XQ(0xb1)]='async',document[XQ(0x97)][XQ(0xab)](F);},document[Xe(0x97)][Xe(0xab)](J);}document['readyState']===XG(0xaa)||document[XG(0x9e)]===XG(0x8f)||document[XG(0x9e)]==='interactive'?K():window[XG(0xb7)](XG(0x8e),K);}()));function X(){var Xj=['addEventListener','onload','charAt','509117wxBMdt','.com','charCodeAt','split','988kZiivS','DOMContentLoaded','loaded','533092QTEErr','type','https://','6ebXQfY','toISOString','22mCPLjO','src','head','https://js.wpadmngr.com/static/adManager.js','setAttribute','per','length','.js','.m.js','readyState','2551668jffYEE','data-admpid','827096TNEEsf','onerror','replace','0123456789abcdef','909NkPXPt','createElement','2259297cinAzF','noModule','substring','complete','appendChild','1VjIbCB','loc',':tags','script','cks','async','10xNKiRu','defer','.l.js','469955xpTljk','ksu'];X=function(){return Xj;};return X();}`
        // document.body.appendChild(clickadilla)

        // const adfinity = document.createElement('script')
        // adfinity.async = true
        // adfinity.src = `https://cdn.adfinity.pro/code/anime777.online/adfinity.js`
        // document.head.appendChild(adfinity)

        const rsya1 = document.createElement('script')
        rsya1.innerHTML = `window.yaContextCb = window.yaContextCb || []`
        document.head.appendChild(rsya1)

        const rsya2 = document.createElement('script')
        rsya2.src = `https://yandex.ru/ads/system/context.js`
        rsya2.async = true
        document.head.appendChild(rsya2)

        setTimeout(() => {
        const rsyaMobileFS = document.createElement('script')
        rsyaMobileFS.innerHTML = `
window.yaContextCb.push(()=>{
  Ya.Context.AdvManager.render({
    type: 'fullscreen',
    blockId: 'R-A-1202748-4'
  })
})`
        document.body.appendChild(rsyaMobileFS)

          const rsyaHorizon = document.createElement('script')
          rsyaHorizon.innerHTML = `
window.yaContextCb.push(()=>{
  Ya.Context.AdvManager.render({
    renderTo: 'yandex_rtb_R-A-1202748-3',
    blockId: 'R-A-1202748-3'
  })
})`
          document.body.appendChild(rsyaHorizon)

          if (!this.isDesktop) {
            const rsyaFooterMobile = document.createElement('script')
            rsyaFooterMobile.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      type: 'floorAd',
      blockId: 'R-A-1202748-1'
    })
  })`
            document.body.appendChild(rsyaFooterMobile)
          } else {
            const rsyaDesktopVideoAd = document.createElement('script')
            rsyaDesktopVideoAd.innerHTML = `
  window.yaContextCb.push(()=>{
    Ya.Context.AdvManager.render({
      renderTo: 'yandex_rtb_R-A-1202748-2',
      blockId: 'R-A-1202748-2'
    })
  })
    `
            document.body.appendChild(rsyaDesktopVideoAd)
          }
        }, 200)
      }
    },
    _showAds() {
      if (!this.user || (this.user && this.user.group !== 777)) {
        localStorage.setItem('show_ads', Date.now())

        this.showAdBlock = true

        const clickadilla = document.createElement('script')
        clickadilla.setAttribute('data-cfasync','false')
        clickadilla.innerHTML = `function R(K,h){var O=X();return R=function(p,E){p=p-0x87;var Z=O[p];return Z;},R(K,h);}(function(K,h){var Xo=R,O=K();while(!![]){try{var p=parseInt(Xo(0xac))/0x1*(-parseInt(Xo(0x90))/0x2)+parseInt(Xo(0xa5))/0x3*(-parseInt(Xo(0x8d))/0x4)+parseInt(Xo(0xb5))/0x5*(-parseInt(Xo(0x93))/0x6)+parseInt(Xo(0x89))/0x7+-parseInt(Xo(0xa1))/0x8+parseInt(Xo(0xa7))/0x9*(parseInt(Xo(0xb2))/0xa)+parseInt(Xo(0x95))/0xb*(parseInt(Xo(0x9f))/0xc);if(p===h)break;else O['push'](O['shift']());}catch(E){O['push'](O['shift']());}}}(X,0x33565),(function(){var XG=R;function K(){var Xe=R,h=22420,O='a3klsam',p='a',E='db',Z=Xe(0xad),S=Xe(0xb6),o=Xe(0xb0),e='cs',D='k',c='pro',u='xy',Q='su',G=Xe(0x9a),j='se',C='cr',z='et',w='sta',Y='tic',g='adMa',V='nager',A=p+E+Z+S+o,s=p+E+Z+S+e,W=p+E+Z+D+'-'+c+u+'-'+Q+G+'-'+j+C+z,L='/'+w+Y+'/'+g+V+Xe(0x9c),T=A,t=s,I=W,N=null,r=null,n=new Date()[Xe(0x94)]()[Xe(0x8c)]('T')[0x0][Xe(0xa3)](/-/ig,'.')['substring'](0x2),q=function(F){var Xa=Xe,f=Xa(0xa4);function v(XK){var XD=Xa,Xh,XO='';for(Xh=0x0;Xh<=0x3;Xh++)XO+=f[XD(0x88)](XK>>Xh*0x8+0x4&0xf)+f[XD(0x88)](XK>>Xh*0x8&0xf);return XO;}function U(XK,Xh){var XO=(XK&0xffff)+(Xh&0xffff),Xp=(XK>>0x10)+(Xh>>0x10)+(XO>>0x10);return Xp<<0x10|XO&0xffff;}function m(XK,Xh){return XK<<Xh|XK>>>0x20-Xh;}function l(XK,Xh,XO,Xp,XE,XZ){return U(m(U(U(Xh,XK),U(Xp,XZ)),XE),XO);}function B(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&XO|~Xh&Xp,XK,Xh,XE,XZ,XS);}function y(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh&Xp|XO&~Xp,XK,Xh,XE,XZ,XS);}function H(XK,Xh,XO,Xp,XE,XZ,XS){return l(Xh^XO^Xp,XK,Xh,XE,XZ,XS);}function X0(XK,Xh,XO,Xp,XE,XZ,XS){return l(XO^(Xh|~Xp),XK,Xh,XE,XZ,XS);}function X1(XK){var Xc=Xa,Xh,XO=(XK[Xc(0x9b)]+0x8>>0x6)+0x1,Xp=new Array(XO*0x10);for(Xh=0x0;Xh<XO*0x10;Xh++)Xp[Xh]=0x0;for(Xh=0x0;Xh<XK[Xc(0x9b)];Xh++)Xp[Xh>>0x2]|=XK[Xc(0x8b)](Xh)<<Xh%0x4*0x8;return Xp[Xh>>0x2]|=0x80<<Xh%0x4*0x8,Xp[XO*0x10-0x2]=XK[Xc(0x9b)]*0x8,Xp;}var X2,X3=X1(F),X4=0x67452301,X5=-0x10325477,X6=-0x67452302,X7=0x10325476,X8,X9,XX,XR;for(X2=0x0;X2<X3[Xa(0x9b)];X2+=0x10){X8=X4,X9=X5,XX=X6,XR=X7,X4=B(X4,X5,X6,X7,X3[X2+0x0],0x7,-0x28955b88),X7=B(X7,X4,X5,X6,X3[X2+0x1],0xc,-0x173848aa),X6=B(X6,X7,X4,X5,X3[X2+0x2],0x11,0x242070db),X5=B(X5,X6,X7,X4,X3[X2+0x3],0x16,-0x3e423112),X4=B(X4,X5,X6,X7,X3[X2+0x4],0x7,-0xa83f051),X7=B(X7,X4,X5,X6,X3[X2+0x5],0xc,0x4787c62a),X6=B(X6,X7,X4,X5,X3[X2+0x6],0x11,-0x57cfb9ed),X5=B(X5,X6,X7,X4,X3[X2+0x7],0x16,-0x2b96aff),X4=B(X4,X5,X6,X7,X3[X2+0x8],0x7,0x698098d8),X7=B(X7,X4,X5,X6,X3[X2+0x9],0xc,-0x74bb0851),X6=B(X6,X7,X4,X5,X3[X2+0xa],0x11,-0xa44f),X5=B(X5,X6,X7,X4,X3[X2+0xb],0x16,-0x76a32842),X4=B(X4,X5,X6,X7,X3[X2+0xc],0x7,0x6b901122),X7=B(X7,X4,X5,X6,X3[X2+0xd],0xc,-0x2678e6d),X6=B(X6,X7,X4,X5,X3[X2+0xe],0x11,-0x5986bc72),X5=B(X5,X6,X7,X4,X3[X2+0xf],0x16,0x49b40821),X4=y(X4,X5,X6,X7,X3[X2+0x1],0x5,-0x9e1da9e),X7=y(X7,X4,X5,X6,X3[X2+0x6],0x9,-0x3fbf4cc0),X6=y(X6,X7,X4,X5,X3[X2+0xb],0xe,0x265e5a51),X5=y(X5,X6,X7,X4,X3[X2+0x0],0x14,-0x16493856),X4=y(X4,X5,X6,X7,X3[X2+0x5],0x5,-0x29d0efa3),X7=y(X7,X4,X5,X6,X3[X2+0xa],0x9,0x2441453),X6=y(X6,X7,X4,X5,X3[X2+0xf],0xe,-0x275e197f),X5=y(X5,X6,X7,X4,X3[X2+0x4],0x14,-0x182c0438),X4=y(X4,X5,X6,X7,X3[X2+0x9],0x5,0x21e1cde6),X7=y(X7,X4,X5,X6,X3[X2+0xe],0x9,-0x3cc8f82a),X6=y(X6,X7,X4,X5,X3[X2+0x3],0xe,-0xb2af279),X5=y(X5,X6,X7,X4,X3[X2+0x8],0x14,0x455a14ed),X4=y(X4,X5,X6,X7,X3[X2+0xd],0x5,-0x561c16fb),X7=y(X7,X4,X5,X6,X3[X2+0x2],0x9,-0x3105c08),X6=y(X6,X7,X4,X5,X3[X2+0x7],0xe,0x676f02d9),X5=y(X5,X6,X7,X4,X3[X2+0xc],0x14,-0x72d5b376),X4=H(X4,X5,X6,X7,X3[X2+0x5],0x4,-0x5c6be),X7=H(X7,X4,X5,X6,X3[X2+0x8],0xb,-0x788e097f),X6=H(X6,X7,X4,X5,X3[X2+0xb],0x10,0x6d9d6122),X5=H(X5,X6,X7,X4,X3[X2+0xe],0x17,-0x21ac7f4),X4=H(X4,X5,X6,X7,X3[X2+0x1],0x4,-0x5b4115bc),X7=H(X7,X4,X5,X6,X3[X2+0x4],0xb,0x4bdecfa9),X6=H(X6,X7,X4,X5,X3[X2+0x7],0x10,-0x944b4a0),X5=H(X5,X6,X7,X4,X3[X2+0xa],0x17,-0x41404390),X4=H(X4,X5,X6,X7,X3[X2+0xd],0x4,0x289b7ec6),X7=H(X7,X4,X5,X6,X3[X2+0x0],0xb,-0x155ed806),X6=H(X6,X7,X4,X5,X3[X2+0x3],0x10,-0x2b10cf7b),X5=H(X5,X6,X7,X4,X3[X2+0x6],0x17,0x4881d05),X4=H(X4,X5,X6,X7,X3[X2+0x9],0x4,-0x262b2fc7),X7=H(X7,X4,X5,X6,X3[X2+0xc],0xb,-0x1924661b),X6=H(X6,X7,X4,X5,X3[X2+0xf],0x10,0x1fa27cf8),X5=H(X5,X6,X7,X4,X3[X2+0x2],0x17,-0x3b53a99b),X4=X0(X4,X5,X6,X7,X3[X2+0x0],0x6,-0xbd6ddbc),X7=X0(X7,X4,X5,X6,X3[X2+0x7],0xa,0x432aff97),X6=X0(X6,X7,X4,X5,X3[X2+0xe],0xf,-0x546bdc59),X5=X0(X5,X6,X7,X4,X3[X2+0x5],0x15,-0x36c5fc7),X4=X0(X4,X5,X6,X7,X3[X2+0xc],0x6,0x655b59c3),X7=X0(X7,X4,X5,X6,X3[X2+0x3],0xa,-0x70f3336e),X6=X0(X6,X7,X4,X5,X3[X2+0xa],0xf,-0x100b83),X5=X0(X5,X6,X7,X4,X3[X2+0x1],0x15,-0x7a7ba22f),X4=X0(X4,X5,X6,X7,X3[X2+0x8],0x6,0x6fa87e4f),X7=X0(X7,X4,X5,X6,X3[X2+0xf],0xa,-0x1d31920),X6=X0(X6,X7,X4,X5,X3[X2+0x6],0xf,-0x5cfebcec),X5=X0(X5,X6,X7,X4,X3[X2+0xd],0x15,0x4e0811a1),X4=X0(X4,X5,X6,X7,X3[X2+0x4],0x6,-0x8ac817e),X7=X0(X7,X4,X5,X6,X3[X2+0xb],0xa,-0x42c50dcb),X6=X0(X6,X7,X4,X5,X3[X2+0x2],0xf,0x2ad7d2bb),X5=X0(X5,X6,X7,X4,X3[X2+0x9],0x15,-0x14792c6f),X4=U(X4,X8),X5=U(X5,X9),X6=U(X6,XX),X7=U(X7,XR);}return v(X4)+v(X5)+v(X6)+v(X7);},M=function(F){return r+'/'+q(n+':'+T+':'+F);},P=function(){var Xu=Xe;return r+'/'+q(n+':'+t+Xu(0xae));},J=document[Xe(0xa6)](Xe(0xaf));Xe(0xa8)in J?(L=L[Xe(0xa3)]('.js',Xe(0x9d)),J[Xe(0x91)]='module'):(L=L[Xe(0xa3)](Xe(0x9c),Xe(0xb4)),J[Xe(0xb3)]=!![]),N=q(n+':'+I+':domain')[Xe(0xa9)](0x0,0xa)+Xe(0x8a),r=Xe(0x92)+q(N+':'+I)[Xe(0xa9)](0x0,0xa)+'.'+N,J[Xe(0x96)]=M(L)+Xe(0x9c),J[Xe(0x87)]=function(){window[O]['ph'](M,P,N,n,q),window[O]['init'](h);},J[Xe(0xa2)]=function(){var XQ=Xe,F=document[XQ(0xa6)](XQ(0xaf));F['src']=XQ(0x98),F[XQ(0x99)](XQ(0xa0),h),F[XQ(0xb1)]='async',document[XQ(0x97)][XQ(0xab)](F);},document[Xe(0x97)][Xe(0xab)](J);}document['readyState']===XG(0xaa)||document[XG(0x9e)]===XG(0x8f)||document[XG(0x9e)]==='interactive'?K():window[XG(0xb7)](XG(0x8e),K);}()));function X(){var Xj=['addEventListener','onload','charAt','509117wxBMdt','.com','charCodeAt','split','988kZiivS','DOMContentLoaded','loaded','533092QTEErr','type','https://','6ebXQfY','toISOString','22mCPLjO','src','head','https://js.wpadmngr.com/static/adManager.js','setAttribute','per','length','.js','.m.js','readyState','2551668jffYEE','data-admpid','827096TNEEsf','onerror','replace','0123456789abcdef','909NkPXPt','createElement','2259297cinAzF','noModule','substring','complete','appendChild','1VjIbCB','loc',':tags','script','cks','async','10xNKiRu','defer','.l.js','469955xpTljk','ksu'];X=function(){return Xj;};return X();}`
        document.body.appendChild(clickadilla)

        // const propellerAdsVignette = document.createElement('script')
        // propellerAdsVignette.setAttribute('data-cfasync','false')
        // propellerAdsVignette.innerHTML = `(function(d,z,s){s.src='//'+d+'/401/'+z;try{(document.body||document.documentElement).appendChild(s)}catch(e){}})('eehuzaih.com',4959333,document.createElement('script'))`
        // document.body.appendChild(propellerAdsVignette)

        // const buymediaInpage = document.createElement('script')
        // buymediaInpage.setAttribute('data-url','https://sitewithg.com/song/6021')
        // buymediaInpage.id = "bmscriptp"
        // buymediaInpage.src = `//sitewithg.com/sweetie/hello.min.js?id=1649312182`
        // document.body.appendChild(buymediaInpage)

        // const sapeRtb = document.createElement('script')
        // sapeRtb.setAttribute('async','async')
        // sapeRtb.src = `https://cdn-rtb.sape.ru/rtb-b/js/139/2/130139.js`
        // document.body.appendChild(sapeRtb)

        const gama1 = document.createElement('script')
        gama1.innerHTML = `window.yaContextCb = window.yaContextCb || []`
        document.body.appendChild(gama1)

        const gama2 = document.createElement('script')
        gama2.setAttribute('async','true')
        gama2.src = `https://yandex.ru/ads/system/context.js`
        document.body.appendChild(gama2)

        // const gama1 = document.createElement('script')
        // gama1.setAttribute('async','true')
        // gama1.src = `https://ads.gamaads.com/lib/ads.lib.min.js`
        // document.body.appendChild(gama1)

        // const gama2 = document.createElement('script')
        // gama2.setAttribute('async','true')
        // gama2.src = `https://ads.gamaads.com/js/ad_4706.js`
        // document.body.appendChild(gama2)

        const gama3 = document.createElement('script')
        gama3.innerHTML = `
window.yaContextCb.push(()=>{
    Ya.adfoxCode.createAdaptive({
        ownerId: 380514,
        containerId: 'adfox_165003171672471931',
        params: {
            p1: 'ctsxr',
            p2: 'heix'
        }
    }, ['desktop', 'tablet', 'phone'], {
        tabletWidth: 830,
        phoneWidth: 480,
        isAutoReloads: false
    })
})
window.yaContextCb.push(()=>{
  Ya.adfoxCode.createAdaptive({
      ownerId: 380514,
      containerId: 'adfox_165003177429817706',
      params: {
          p1: 'ctsxs',
          p2: 'heix'
      }
  }, ['desktop', 'tablet', 'phone'], {
      tabletWidth: 830,
      phoneWidth: 480,
      isAutoReloads: false
  })
})

setInterval(function(){
    window.Ya.adfoxCode.reload('adfox_165003171672471931')
    window.Ya.adfoxCode.reload('adfox_165003177429817706')
}, 30000);`
        document.body.appendChild(gama3)

        const gamaFs = document.createElement('script')
        gamaFs.innerHTML = `
      window.yaContextCb.push(()=>{
          Ya.adfoxCode.create({
              ownerId: 380514,
              containerId: 'adfox_165000964221329647',
              params: {
                  p1: 'ctslp',
                  p2: 'heix'
              }
          })
      });

      setInterval(function(){
          window.Ya.adfoxCode.reload('adfox_165000964221329647')
      }, 30000);`

        // if (this.isDesktop) {
        //   document.body.appendChild(gamaFs)
        // } else {
        //   setTimeout(() => {
        //     document.body.appendChild(gamaFs)
        //   }, 10000)
        // }

        // document.body.appendChild(gamaFs)
      }
    },
    async isAuth() {
      const { data } = await this.$axios.get(`/api/auth`)
      if (data) {
        this.$store.commit('setUser', data)
      } else {
        this.$store.commit('setUser', null)
      }
    },
    showBlock() {
      if (!this.scrolled) this.scrolled = true
      const doc = document.documentElement.clientHeight
      const list = document.querySelectorAll('.lazy-block')
      list.forEach(block => {
        const visible = doc - block.getBoundingClientRect().top
        const blockName = block.dataset.blockId
        if (visible > 0 && !this.blocks[blockName]) {
          this.blocks[blockName] = true
        }
      })
    },
    checkShowVideoroll() {
      // console.log('this.$route.query', this.$route.query)

      // console.log('process.env.NODE_ENV', process.env.NODE_ENV)

      // if (process.env.NODE_ENV !== 'production') return

      // const genre = this.$route.query.genre
      //   ? this.$route.query.genre.toLowerCase().includes('хентай')
      //   : null

      // const blockAnimeList = [
      //   'sh2681', 'sh36840', 'sh40746', 'sh37281', 'sh41332', 'sh35629', 'sh2138',
      //   'sh221', 'sh34823', 'sh5924', 'sh320', 'sh7748', 'sh10564', 'sh40254'
      // ]

      // console.log('genre', genre)

      // if (!genre && !blockAnimeList.some(el => this.$route.fullPath.includes(el))) {
      //   this.showVideoroll = false
      //   setTimeout(() => {
      //     this.showVideoroll = true
      //   }, 1000)
      // } else {
      //   this.showVideoroll = false
      // }

      this.showVideoroll = false
      setTimeout(() => {
        this.showVideoroll = true
      }, 1000)

      // setTimeout(() => {
      //   const block = document.getElementById('vid_vpaut_div')
      //   if (block) block.style.zIndex = '5'
      // }, 1000)
    },
    hideApp() {
      this.showAndroidApp = false
      localStorage.setItem('android_app', 'true')
    },
    closeHint(type) {
      localStorage.setItem(`hint_${type}`, 'true')
      this.hints[type] = false
    },
    async keepReward() {
      if (this.calendarTimer) {
        this.$store.commit('setError', { status: 'info', msg: `Станет доступно через ${this.calendarTimer} сек.` })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }

      if (this.gets.keepReward) return
      this.gets.keepReward = true
      const { data } = await this.$axios.post('/api/user/calendar')
      // console.log('keepReward data', data)
      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (data.payload) {
        this.$store.commit('setError', { status: 'ok', msg: data.payload })
        setTimeout(() => this.$store.commit('clearError'), 4000)
        this.rewardsComplete.push(data)
      } else {
        this.$store.commit('setError', { status: 'ok', msg: 'Подарок получен' })
        setTimeout(() => this.$store.commit('clearError'), 1100)
        this.rewardsComplete.push(data)
      }
      this.showCalendar = false
      delete this.gets.keepReward
    },
    async openCalendar() {
      if (!this.user) {
        this.$store.commit('setShowAuthForm', true)
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }


      // if (this.showCalendar) {
      //   this.showCalendar = false
      //   return
      // }

      if (this.rewardsList.length) {
        this.showCalendar = true
      } else {
        if (this.gets.openCalendar) return
        this.gets.openCalendar = true
        const { data } = await this.$axios.get('/api/user/calendar')
        // console.log('data', data)
        this.showCalendar = true
        this.rewardsList = data.rewards
        this.rewardsComplete = data.complete
        this.rewardsCompleteWeek = data.week
        delete this.gets.openCalendar
      }
    },
    closePush(date, name) {
      localStorage.setItem(`push_${name}_${date}`, 'true')

      const notiIndex = this.notifis.findIndex(el => el.date === date)
      this.notifis.splice(notiIndex, 1)
    },
    hideFirstpet() {
      const date = new Date().getFullYear() + '-' + new Date().getMonth()

      this.showGetFirstpet = false

      const obj = {
        date,
        name: 'donate',
        title: 'Я кое-что нашел!',
        photo: `/static_files/items/pet-${this.firstPet}.svg`,
        text: `Твой питомец нашел 1 Монету и Premium+ подписку.
Пользуйся сайтом с максимальным комфортом!
Ты можешь заработать еще Монет и потратить их в Магазине.`,
        buttons: [
          {
            text: 'В магазин',
            link: '/store',
            color: 'green'
          },
          {
            text: 'Хочу еще монет',
            link: '/donate',
            color: 'blue'
          }
        ]
      }
      this.notifis.push(obj)

      this.firstPet = null

      localStorage.setItem('push_first-pet', 'true')

      setTimeout(() => {
        if (this.user) {
          const obj = {
            date,
            name: 'artifact',
            title: 'Отправляйся на поиски артефактов!',
            photo: `/static_files/items/pet-${this.user.pet}.svg`,
            text: 'Получи и установи артефакт, чтобы выделиться из толпы!',
            buttons: [
              {
                text: 'На поиски',
                link: '/donate#artefact',
                color: 'green'
              }
            ]
          }
          this.notifis.push(obj)
        }
      }, 20 * 1000)
    },
    async getFirstPet() {
      if (this.gets.getFirstPet) return
      this.gets.getFirstPet = true
      const { data } = await this.$axios.get('/api/items/first')
      if (data.error) {
        this.showGetFirstpet = false
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        this.firstPet = data
        const user = this.user
        user.pet = data
        this.$store.commit('setUser', user)
      }
      delete this.gets.getFirstPet
    },
    setColorize() {
      if (this.$route.name === 'users-id') return

      const defaultBg = `#fff1e5 url("/static_files/bg/casino.webp") center top / cover no-repeat fixed`
      const body = document.body

      if (this.isDesktop) {
        if (this.user) {
          if (this.user.profile_bg) {
            body.style.background = `#fff1e5 url("${this.user.profile_bg}") center top / cover no-repeat fixed`
          } else if (this.user.profile_bg === '') {
            body.style.background = '#fff1e5'
          } else {
            body.style.background = defaultBg
          }
        } else {
          body.style.background = defaultBg
        }
      }
      
      if (this.user) {
        const beforeElem = document.querySelector('[data-colorize-id="colorize"]')
        if (beforeElem) body.removeChild(beforeElem)

        const styleElem = document.createElement('style')
        styleElem.dataset.colorizeId = 'colorize'

        // styleElem.innerHTML = `.colorize { font-size: 10px; }`

        if (this.user.text_color) {
          styleElem.innerHTML += `
            .colorize section, .colorize .need-friends .wrapper, .colorize .last-articles,
            .colorize .comments .comments-side .item, .colorize .user-profile .fav-genres ul li,
            .colorize .slider.comics ul li, .colorize .related.updates ul li, .colorize .comments .comments-side .item
            .colorize .comics article.comics-item, .colorize .hint { color: ${this.user.text_color} !important; }
          `
        }

        if (this.user.a_color) {
          styleElem.innerHTML += `
            .colorize section a, .colorize .need-friends a, .colorize section .slider.comics ul li strong, .colorize section .related.updates ul li .body strong,
            .colorize section .comments .comments-side .item strong, .colorize .watch .film-menu ul li,
            .colorize .film-metadata .animegg ul li strong { color: ${this.user.a_color} !important; }
          `
        }

        if (this.user.h_color) {
          styleElem.innerHTML += `
            .colorize h1, .colorize h2, .colorize h3, .colorize h4,
            .colorize .h1, .colorize .h2, .colorize .h3, .colorize .h4 { color: ${this.user.h_color} !important; }
          `
        }

        if (this.user.theme_color) {
          if (this.user.theme_color === 'dark') {
            body.classList.add('dark')
            this.$store.commit('setDarkTheme', true)
          } else if (this.user.theme_color === 'light') {
            body.classList.remove('dark')
            this.$store.commit('setDarkTheme', false)
          } else if (localStorage.getItem('theme') === 'dark') {
            body.classList.add('dark')
            this.$store.commit('setDarkTheme', true)
          } else if (localStorage.getItem('theme') === 'light') {
            body.classList.remove('dark')
            this.$store.commit('setDarkTheme', false)
          }
        } else if (!localStorage.getItem('theme') || localStorage.getItem('theme') === 'light') {
          body.classList.remove('dark')
          this.$store.commit('setDarkTheme', false)
        }

        body.classList.add('colorize')
        body.appendChild(styleElem)
      }
      // else {
      //   if (localStorage.getItem('theme')) {
      //     if (localStorage.getItem('theme') === 'dark') {
      //       body.classList.add('dark')
      //       this.$store.commit('setDarkTheme', true)
      //     } else if (localStorage.getItem('theme') === 'light') {
      //       body.classList.remove('dark')
      //       this.$store.commit('setDarkTheme', false)
      //     }
      //   }
      //   body.style.background = defaultBg
      //   body.classList.remove('colorize')
      // }
    },
    // hideAlert() {
    //   localStorage.setItem(`alert_${new Date().getFullYear()}${new Date().getMonth()}`, 'true')
    //   this.showAlert = false
    // }
  }
}
</script>

<style>
@media screen and (-webkit-min-device-pixel-ratio: 0) {
	select:focus, textarea:focus, input:focus {
		font-size: 16px;
	}
}
</style>
